import { render, staticRenderFns } from "./CategorySingle.vue?vue&type=template&id=61af75d7&scoped=true&"
import script from "./CategorySingle.vue?vue&type=script&lang=js&"
export * from "./CategorySingle.vue?vue&type=script&lang=js&"
import style0 from "./CategorySingle.vue?vue&type=style&index=0&id=61af75d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af75d7",
  null
  
)

export default component.exports